export const getSalePeriod = (
  shopConfiguration: any,
): { from: Date; to: Date } | undefined => {
  const { SaleValidFrom, SaleValidTo } = shopConfiguration?.customData ?? {}

  if (SaleValidFrom && SaleValidTo) {
    return {
      from: new Date(SaleValidFrom.split('.').reverse().join('-')),
      to: new Date(SaleValidTo.split('.').reverse().join('-')),
    }
  }

  return undefined
}

export const isShopActiveSalePeriod = (shopConfiguration: any): boolean => {
  const salePeriod = getSalePeriod(shopConfiguration)

  if (salePeriod) {
    const currentDate = new Date()

    return (
      salePeriod.from.getTime() < currentDate.getTime() &&
      salePeriod.to.getTime() > currentDate.getTime()
    )
  }

  return true
}

export const getDeliveryEstimationInDays = (shopConfiguration: any) => {
  const { DeliveryEstimationInDays } = shopConfiguration?.customData ?? {}
  return DeliveryEstimationInDays as number | undefined
}
